<h2 class="page-heading">
	<svg width="38" height="38" viewBox="0 0 38 38">
		<g class="svg-stroke" fill="none" fill-rule="evenodd" stroke-width="2">
			<path
				d="M36.598 13.897l-1.715-4.139-1.177-.538-2.032.677-1.05-.33a14.846 14.846 0 0 0-2.53-2.526c-.12-.387-.206-.663-.328-1.049l.677-2.034c-.207-.453-.33-.725-.538-1.178l-4.139-1.715-1.213.453-.96 1.917-.974.51a14.9 14.9 0 0 0-3.576-.003l-.974-.51-.959-1.914-1.212-.453-4.14 1.715c-.207.453-.33.725-.538 1.178l.676 2.032-.328 1.048a14.915 14.915 0 0 0-2.527 2.53l-1.05.33-2.033-.678c-.454.207-.725.33-1.178.538l-1.714 4.14.452 1.213 1.917.96.51.973a14.856 14.856 0 0 0-.003 3.576l-.509.974-1.915.958-.452 1.214 1.714 4.14 1.178.537 2.032-.676 1.048.328a14.877 14.877 0 0 0 2.53 2.526l.33 1.05-.678 2.035.539 1.177 4.138 1.715 1.213-.453.96-1.917.975-.51c1.175.143 2.375.148 3.575.004l.975.508.958 1.915 1.213.453 4.14-1.715.537-1.177-.677-2.032.33-1.05a14.91 14.91 0 0 0 2.526-2.53c.387-.12.663-.207 1.05-.329l2.034.678 1.177-.537 1.715-4.14-.452-1.214-1.918-.959-.51-.974c.143-1.176.148-2.375.003-3.576l.51-.974 1.915-.958.452-1.214z" />
			<path
				d="M27.602 18.736c0 4.841-3.931 8.766-8.78 8.766-4.85 0-8.781-3.925-8.781-8.766 0-4.84 3.93-8.765 8.78-8.765s8.78 3.925 8.78 8.765z" />
		</g>
	</svg>

	<ng-container i18n="@@general.account_setting">Account Settings</ng-container>
</h2><!-- data-table__heading -->

<div class="account-setting white-bg">
	<div class="account-setting__content">
		<account-setting [userDetails]="userInfo"></account-setting>
		<ng-container *ngIf="isSuperAdmin()">
			<whatsapp-notification [userDetails]="userInfo"></whatsapp-notification>
			<!-- <app-wallet [userDetails]="basicInfo"></app-wallet> -->
			<merchant-info [userDetails]="userInfo"></merchant-info>
			<business-information [userDetails]="userInfo"></business-information>
		</ng-container>
		<div id="targetScroll" class="account-setting__plans">
			<ng-container *ngIf="isSuperAdmin() && !experimentInfo">
				<!-- <ng-container *ngIf="!isVerifyAtGreater()">
					<manage-plan class="w-100" [plans]="plans" [userDetails]="userInfo" (onPlanChange)="onPlanChange()"></manage-plan>
				</ng-container>
				<ng-container *ngIf="isVerifyAtGreater()">
					<h3 class="dotted">
						<span>
							<ng-container i18n="@@setting.plan">Plans</ng-container>
						</span>
					</h3>
					<subscription-plan class="w-100"></subscription-plan>
				</ng-container> -->
				<h3 class="dotted">
					<span>
						<ng-container i18n="@@setting.plan">Plans</ng-container>
					</span>
				</h3>
				<subscription-plan class="w-100"></subscription-plan>
			</ng-container>
		</div>
	</div>
</div>

<!-- <app-profile></app-profile> -->

<div class="white-bg" style="padding-top: 80px;" *ngIf="isSuperAdmin()">
	<h3 class="white dotted">
		<span>
			<ng-container i18n="@@setting.terminate_account">Terminate account</ng-container>
		</span>
	</h3>
	<p>&nbsp;</p>
	<form>
		<fieldset>
			<span i18n="@@setting.this_will_terminate_account">This will terminate your account</span>
			<div class="account-setting__actionButtonsWrap">
				<button type="button" class="tu-btn pink save-btn" i18n="@@button.terminate" (click)="terminateAccount()">Terminate</button>
			</div>
		</fieldset>
	</form>
</div>
